import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Notice the lack of protection",
    opening: localizedGenderNode(
      [
      "Today I don't try to fix it.",
      "I just notice the lack of protection.",
      "That is enough for now."
    ],
      [
      "Today I don't try to fix it.",
      "I just notice the lack of protection.",
      "That is enough for now."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When is the lack of protection most felt?",
      "What is happening around me then?",
      "How does it feel in my body?"
    ],
      [
      "When is the lack of protection most felt?",
      "What is happening around me then?",
      "How does it feel in my body?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Noticing is already the beginning of inner protection."
    ],
      [
      "Noticing is already the beginning of inner protection."
    ]
    ),
    action: localizedGenderNode(
      "one breath with the words \"I am here\".",
      "one breath with the words \"I am here\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "What I needed",
    opening: localizedGenderNode(
      [
      "Today I notice what I needed then.",
      "Without blame.",
      "Just to see."
    ],
      [
      "Today I notice what I needed then.",
      "Without blame.",
      "Just to see."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my chest."
    ],
      [
      "I breathe slowly.",
      "I feel my chest."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I need to hear then?",
      "What did I need to happen?",
      "What still feels missing today?"
    ],
      [
      "What did I need to hear then?",
      "What did I need to happen?",
      "What still feels missing today?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Noticing the need is already gentleness."
    ],
      [
      "Noticing the need is already gentleness."
    ]
    ),
    action: localizedGenderNode(
      "write one word about the need.",
      "write one word about the need."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "How it stayed in me",
    opening: localizedGenderNode(
      [
      "Today I notice what stayed in me since then.",
      "Without judgment.",
      "Just truth."
    ],
      [
      "Today I notice what stayed in me since then.",
      "Without judgment.",
      "Just truth."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where does it meet me today?",
      "What am I trying to keep myself from feeling?",
      "How does it affect relationships?"
    ],
      [
      "Where does it meet me today?",
      "What am I trying to keep myself from feeling?",
      "How does it affect relationships?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "What stayed in me asks for gentleness."
    ],
      [
      "What stayed in me asks for gentleness."
    ]
    ),
    action: localizedGenderNode(
      "tell myself \"I see you\".",
      "tell myself \"I see you\"."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "The part that feels unprotected",
    opening: localizedGenderNode(
      [
      "Today I notice the part in me that feels unprotected.",
      "Not to fix.",
      "Just to be with it."
    ],
      [
      "Today I notice the part in me that feels unprotected.",
      "Not to fix.",
      "Just to be with it."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my heart."
    ],
      [
      "I breathe slowly.",
      "I feel my heart."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where does it sit in me?",
      "What does it need from me now?",
      "How does it feel to be with it for a moment?"
    ],
      [
      "Where does it sit in me?",
      "What does it need from me now?",
      "How does it feel to be with it for a moment?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Being with it for a moment is already a small change."
    ],
      [
      "Being with it for a moment is already a small change."
    ]
    ),
    action: localizedGenderNode(
      "place a hand on my heart and breathe.",
      "place a hand on my heart and breathe."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "The fear no one will be there",
    opening: localizedGenderNode(
      [
      "Today I notice the fear that no one will be there.",
      "Not to fight.",
      "Just to see."
    ],
      [
      "Today I notice the fear that no one will be there.",
      "Not to fight.",
      "Just to see."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What am I afraid of here?",
      "What do I think will happen if I ask?",
      "How does this fear protect me?"
    ],
      [
      "What am I afraid of here?",
      "What do I think will happen if I ask?",
      "How does this fear protect me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Fear is asking for protection."
    ],
      [
      "Fear is asking for protection."
    ]
    ),
    action: localizedGenderNode(
      "tell myself \"I see you\".",
      "tell myself \"I see you\"."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "A small request for protection",
    opening: localizedGenderNode(
      [
      "Today I form a small request for protection.",
      "Not big.",
      "Small."
    ],
      [
      "Today I form a small request for protection.",
      "Not big.",
      "Small."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe.",
      "I am here."
    ],
      [
      "I breathe.",
      "I am here."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What gives me a small sense of protection?",
      "How can I ask for it gently?",
      "What is a small step toward it?"
    ],
      [
      "What gives me a small sense of protection?",
      "How can I ask for it gently?",
      "What is a small step toward it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One request can calm me."
    ],
      [
      "One request can calm me."
    ]
    ),
    action: localizedGenderNode(
      "write the request in one sentence.",
      "write the request in one sentence."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "A small moment of safety",
    opening: localizedGenderNode(
      [
      "Today I look for a small moment of safety.",
      "Not much.",
      "Just a little."
    ],
      [
      "Today I look for a small moment of safety.",
      "Not much.",
      "Just a little."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When did I feel a small safety recently?",
      "What allowed it to happen?",
      "What could invite another moment like that?"
    ],
      [
      "When did I feel a small safety recently?",
      "What allowed it to happen?",
      "What could invite another moment like that?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small moment shifts direction."
    ],
      [
      "A small moment shifts direction."
    ]
    ),
    action: localizedGenderNode(
      "remember one such moment.",
      "remember one such moment."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "A boundary that protects me",
    opening: localizedGenderNode(
      [
      "Today I check a small boundary that protects me.",
      "Not to distance.",
      "Just to protect."
    ],
      [
      "Today I check a small boundary that protects me.",
      "Not to distance.",
      "Just to protect."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my shoulders."
    ],
      [
      "I breathe slowly.",
      "I feel my shoulders."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where do I give too much?",
      "What small boundary would ease me?",
      "How can I say it to myself?"
    ],
      [
      "Where do I give too much?",
      "What small boundary would ease me?",
      "How can I say it to myself?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small boundary protects the heart."
    ],
      [
      "A small boundary protects the heart."
    ]
    ),
    action: localizedGenderNode(
      "one boundary sentence to myself.",
      "one boundary sentence to myself."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Staying with myself",
    opening: localizedGenderNode(
      [
      "Today I practice staying with myself when the lack of protection rises.",
      "Not running away.",
      "Just being."
    ],
      [
      "Today I practice staying with myself when the lack of protection rises.",
      "Not running away.",
      "Just being."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What helps me stay with me?",
      "What takes me away from me?",
      "What could help me return?"
    ],
      [
      "What helps me stay with me?",
      "What takes me away from me?",
      "What could help me return?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Staying with me is a small anchor."
    ],
      [
      "Staying with me is a small anchor."
    ]
    ),
    action: localizedGenderNode(
      "one breath each time the feeling rises.",
      "one breath each time the feeling rises."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "One clear request",
    opening: localizedGenderNode(
      [
      "Today I form one clear request for myself.",
      "Not big.",
      "Clear."
    ],
      [
      "Today I form one clear request for myself.",
      "Not big.",
      "Clear."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe.",
      "I am here."
    ],
      [
      "I breathe.",
      "I am here."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I need right now to feel protected?",
      "How can I ask for it gently?",
      "What is a small step toward it?"
    ],
      [
      "What do I need right now to feel protected?",
      "How can I ask for it gently?",
      "What is a small step toward it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One clear request can calm me."
    ],
      [
      "One clear request can calm me."
    ]
    ),
    action: localizedGenderNode(
      "write the request in one sentence.",
      "write the request in one sentence."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "One value that holds me",
    opening: localizedGenderNode(
      [
      "Today I look for one value that holds me.",
      "Small.",
      "But true."
    ],
      [
      "Today I look for one value that holds me.",
      "Small.",
      "But true."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Which value matters to me inside a bond?",
      "How does that value look on an ordinary day?",
      "What small step could honor it?"
    ],
      [
      "Which value matters to me inside a bond?",
      "How does that value look on an ordinary day?",
      "What small step could honor it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One value is a thread of stability."
    ],
      [
      "One value is a thread of stability."
    ]
    ),
    action: localizedGenderNode(
      "one word that expresses the value.",
      "one word that expresses the value."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Listening to my need",
    opening: localizedGenderNode(
      [
      "Today I listen to my need.",
      "Not to push it away.",
      "Just to hear it."
    ],
      [
      "Today I listen to my need.",
      "Not to push it away.",
      "Just to hear it."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my belly."
    ],
      [
      "I breathe slowly.",
      "I feel my belly."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is the most alive need in me now?",
      "How does it sound in simple words?",
      "What could give it a small place?"
    ],
      [
      "What is the most alive need in me now?",
      "How does it sound in simple words?",
      "What could give it a small place?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Hearing the need is already a change."
    ],
      [
      "Hearing the need is already a change."
    ]
    ),
    action: localizedGenderNode(
      "write the need in one word.",
      "write the need in one word."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "A small step of safety",
    opening: localizedGenderNode(
      [
      "Today I choose a small step of safety.",
      "No drama.",
      "A small step."
    ],
      [
      "Today I choose a small step of safety.",
      "No drama.",
      "A small step."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small step am I willing to try?",
      "What will feel safe enough?",
      "How will it protect me?"
    ],
      [
      "What small step am I willing to try?",
      "What will feel safe enough?",
      "How will it protect me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small step is enough to get closer."
    ],
      [
      "A small step is enough to get closer."
    ]
    ),
    action: localizedGenderNode(
      "choose one small step and remember it.",
      "choose one small step and remember it."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Return sentence",
    opening: localizedGenderNode(
      [
      "Today I choose a sentence that brings me back to inner protection.",
      "When I get scared.",
      "A small sentence."
    ],
      [
      "Today I choose a sentence that brings me back to inner protection.",
      "When I get scared.",
      "A small sentence."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe.",
      "I am here."
    ],
      [
      "I breathe.",
      "I am here."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I learn about this lack of protection?",
      "What is the first sign it returns?",
      "Which sentence brings me back a moment before?"
    ],
      [
      "What did I learn about this lack of protection?",
      "What is the first sign it returns?",
      "Which sentence brings me back a moment before?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I can feel unprotected and still stay with myself."
    ],
      [
      "I can feel unprotected and still stay with myself."
    ]
    ),
    action: localizedGenderNode(
      "say the new sentence once.",
      "say the new sentence once."
    ),
  },
].map(buildNormalizedDay);

export const lackOfProtectionChildhoodWereNotThereForMeBlueprintEn = buildNormalizedPilotBlueprint({
  id: "lack_of_protection_childhood_were_not_there_for_me_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "lack_of_protection_childhood_were_not_there_for_me",
  category: "childhood_parents_past_wounds",
  journeyName: {
    he: "חוסר הגנה בילדות (לא היו שם בשבילי)",
    en: "Lack of protection in childhood (they were not there for me)",
    es: "Falta de protección en la infancia (no estuvieron para mí)",
  },
  days,
});

export default lackOfProtectionChildhoodWereNotThereForMeBlueprintEn;
